import { employeeSchema } from "@/components/Forms/schema/employeeSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceSelector } from "jsonapi-zod-query";

const employeeSelector = createResourceSelector({
    type: "employee",
    attributesSchema: employeeSchema,
});

export type CaseForm = ReturnType<typeof employeeSelector>;

export const useFetchEmployee = (
    employeeId: string | undefined,
): UseQueryResult<CaseForm | undefined> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["employee", employeeId],
        queryFn: async ({ signal }) => {
            if (!employeeId) {
                return undefined;
            }
            const url = apiUrl(`/employee/employee/${employeeId}`);

            const response = await fetch(url, {
                signal,
                headers: {
                    accept: "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: employeeSelector,
    });
};
